import BaseStore from '../../components/BaseStore'
import EventKey from './EventKey'

export default {
  extends: BaseStore,
  computed: {
    apiKey () {
      throw new Error(`Must implement 'apiKey' computed`)
    },
    isReturn () {
      return this.profileSites.length === 0 || this.profileSiteDevices.length === 0
    }
  },
  methods: {
    getQuery: query => query,
    onRealDataReceived (data) {
      throw new Error(`Must implement 'onRealDataReceived' method`)
    },
    [EventKey.REAL_QUERY] (isFirst) {
      if (this.isReturn) {
        return
      }

      if (isFirst) {
        if (this.isInited) {
          return
        } else {
          this.isInited = true
        }
      }

      let {apiKey} = this
      if (!Array.isArray(apiKey)) {
        apiKey = [apiKey]
      }

      apiKey.forEach(apiKey => {
        this.$cancelRequests([`Overview/${apiKey}`])
      })

      Promise.all(apiKey.map(apiKey => this.$api.Overview[apiKey]()))
        .then(data => this.onRealDataReceived(Array.isArray(this.apiKey) ? data : data[0]))
        .catch(console.error)
    }
  },
  created () {
    this.$eventBus.on(EventKey.REAL_QUERY, this[EventKey.REAL_QUERY])
  },
  beforeDestroy () {
    this.$eventBus.off(EventKey.REAL_QUERY, this[EventKey.REAL_QUERY])

    let {apiKey} = this
    if (!Array.isArray(apiKey)) {
      apiKey = [apiKey]
    }

    apiKey.forEach(apiKey => {
      this.$cancelRequests([`Overview/${apiKey}`])
    })
  }
}



// WEBPACK FOOTER //
// ./src/views/01Data-Overview/BaseModule.js